import { Injectable } from '@angular/core';
import { setForm, setProductJSON } from 'src/app/multi_product/policy/generic-input/inputs-names-utils';
import { replacer } from '../util/util';

@Injectable({
  providedIn: 'root',
})
export class IndexDBService {
  private connection: IDBDatabase;

  private dbName: string = 'artico_mp';

  private initialized: Promise<void>;

  constructor() {
    this.initialized = this.connectToDB()
  }

  async connectToDB(): Promise<void> {
    return new Promise((resolve, reject) => {
      const request = indexedDB.open(this.dbName);

      request.onupgradeneeded = () => {
        const db = request.result;
        if (!db.objectStoreNames.contains('storage')) {
          db.createObjectStore('storage', { keyPath: 'key' });
        }
      };

      request.onsuccess = () => {
        this.connection = request.result;
        resolve();
      };

      request.onerror = () => {
        reject(request.error);
      };
    });
  }

  async setItem(key: string, value: any, isReplacer = false): Promise<void> {

    const stringValue = isReplacer ? JSON.stringify(value, replacer) : JSON.stringify(value);
    if (key === 'productJSON') setProductJSON(value);
    if (key === 'form') setForm(JSON.parse(stringValue));
    const table = this.getTableTransactionable();
    const toSave = { key, stringValue };

    return new Promise((resolve, reject) => {
      const request = table.put(toSave);

      request.onsuccess = () => {
        resolve();
      };

      request.onerror = () => {
        reject(request.error);
      };
    });
  }

  async ensureInitialized(): Promise<void> {
    return this.initialized;
  }

  async getItemByKey(key: string): Promise<any> {
    return new Promise((resolve, reject) => {
      const table = this.getTableTransactionable();
      const request = table.get(key);

      request.onsuccess = () => {
        try {
          const result = request.result?.stringValue;
          const parsedValue = typeof result === 'string' ? JSON.parse(result) : result;
          if (key === 'productJSON') setProductJSON(parsedValue);
          if (key === 'form') setForm(parsedValue);
          resolve(parsedValue);
        } catch (error) {
          reject(error);
        }
      };

      request.onerror = () => {
        reject(request.error);
      };
    });
  }

  private getTableTransactionable() {
    if (!this.connection) {
      throw new Error('DB connection not initialized yet');
    }
    const transaction = this.connection.transaction('storage', 'readwrite');
    return transaction.objectStore('storage');
  }

  async deleteItem(key: string): Promise<void> {
    return new Promise((resolve, reject) => {
      const table = this.getTableTransactionable();
      const request = table.delete(key);

      request.onsuccess = () => resolve();
      request.onerror = () => reject(request.error);
    });
  }
}
